import { useEffect } from "react";

export const useInterval = (
  listener: () => void,
  intervalInMs: number,
  deps: React.DependencyList = []
) => {
  useEffect(() => {
    const interval = setInterval(listener, intervalInMs);
    return () => clearInterval(interval);
  }, [listener, ...deps]);
};
